import React from "react";
import { Box, Button, FormControl, FormLabel, Flex, Select } from "@chakra-ui/react";
import { countries } from "countries-list";

const generateFormFields = (fields, formData, setFormData) => {
  return fields.map(({ label, options, key }) => (
    <FormControl id={key} mb="4" key={key}>
      <FormLabel>{label}</FormLabel>
      <Select
        value={formData[key]}
        onChange={(e) => setFormData({ ...formData, [key]: e.target.value })}
      >
        <option defaultValue disabled value="">
          Select an option
        </option>
        {options.map((option) => (
          <option value={option.value} key={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
    </FormControl>
  ));
};

function Step1({ setFormData, formData, setCurrentStep }) {
  const countryNames = Object.values(countries).map((country) => {
    return { label: country.name, value: country.name };
  });

  const agreementTypes = [
    { label: "Purchase Agreement", value: "Purchase Agreement" },
    { label: "Lease Agreement", value: "Lease Agreement" },
    { label: "Employment Agreement", value: "Employment Agreement" },
    { label: "Partnership Agreement", value: "Partnership Agreement" },
    { label: "Joint Venture Agreement", value: "Joint Venture Agreement" },
    { label: "Non-Disclosure Agreement (NDA)", value: "Non-Disclosure Agreement (NDA)" },
    { label: "Non-Compete Agreement", value: "Non-Compete Agreement" },
    { label: "Service Agreement", value: "Service Agreement" },
    { label: "Licensing Agreement", value: "Licensing Agreement" },
    { label: "Loan Agreement", value: "Loan Agreement" },
    { label: "Sales Agreement", value: "Sales Agreement" },
    { label: "Franchise Agreement", value: "Franchise Agreement" },
    { label: "Confidentiality Agreement", value: "Confidentiality Agreement" },
    { label: "Distribution Agreement", value: "Distribution Agreement" },
    { label: "Settlement Agreement", value: "Settlement Agreement" },
    { label: "Insurance Policy", value: "Insurance Policy" },
    { label: "Mergers and Acquisition Agreement", value: "Mergers and Acquisition Agreement" },
    { label: "Intellectual Property Agreement", value: "Intellectual Property Agreement" },
    { label: "Supply Agreement", value: "Supply Agreement" },
    { label: "Agency Agreement", value: "Agency Agreement" },
  ];

  const fieldsConfig = [
    {
      label: "Select Agreement Type",
      key: "agreementType",
      options: agreementTypes,
    },
    {
      label: "Select Country",
      key: "country",
      options: countryNames,
    },
  ];

  return (
    <Box>
      {generateFormFields(fieldsConfig, formData, setFormData)}
      <Flex justifyContent="flex-end">
        <Button
          isDisabled={formData.agreementType === "" || formData.country === ""}
          bgColor="navy.400"
          color="white"
          _hover={{ color: "black", bgColor: "gray.200" }}
          onClick={() => setCurrentStep(2)}
        >
          Next
        </Button>
      </Flex>
    </Box>
  );
}

export default Step1;
